var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Stellenprofil veröffentlichen",
        size: "lg",
        "ok-text": "Jetzt veröffentlichen",
        "hide-ok": !_vm.publishable,
        "hide-cancel": _vm.publishing,
        "cancel-text": _vm.publishable ? "Abbrechen" : "Schließen",
        "ok-disabled": _vm.publishing,
        "ok-loading": _vm.publishing
      },
      on: {
        ok: _vm.publish,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c(
          "div",
          { staticClass: "mr-4" },
          [
            _c("Icon", {
              attrs: {
                icon: _vm.publishableChecklist.inquiries
                  ? "check-circle"
                  : "cross-circle",
                color: _vm.publishableChecklist.inquiries ? "green" : "red",
                size: "2x"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "font-weight-extra-bold" }, [
            _vm._v("Stellenprofil")
          ]),
          _vm._v(" "),
          !_vm.publishableChecklist.inquiries
            ? _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\t\tDein Stellenprofil ist noch nicht vollständig.\n\t\t\t"
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex align-items-center mt-3" }, [
        _c(
          "div",
          { staticClass: "mr-4" },
          [
            _c("Icon", {
              attrs: {
                icon: _vm.publishableChecklist.legitimation
                  ? "check-circle"
                  : "cross-circle",
                color: _vm.publishableChecklist.legitimation ? "green" : "red",
                size: "2x"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("div", [
          _c("div", { staticClass: "font-weight-extra-bold" }, [
            _vm._v("Legitimierung")
          ]),
          _vm._v(" "),
          !_vm.publishableChecklist.legitimation
            ? _c("div", { staticClass: "mt-2" }, [
                _vm._v(
                  "\n\t\t\t\tDu hast deinen Account noch nicht vollständig legitimiert. Bitte erledige das unter\n\t\t\t\t"
                ),
                _c("a", { attrs: { href: "/kundenbereich/sicherheit" } }, [
                  _vm._v("Daten & Sicherheit")
                ]),
                _vm._v(".\n\t\t\t")
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _vm.publishable
        ? _c("div", { staticClass: "mt-4" }, [
            _c("div", [
              _vm._v(
                "\n\t\t\tSuper, du hast alles erledigt und kannst dein Stellenprofil nun veröffentlichen.\n\t\t\tDamit kannst du Kandidaten zu deinem Stellenprofil finden.\n\t\t"
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-2" }, [
              _vm._v(
                "Nach Veröffentlichung scheint dein Stellenprofil auch für Kandidaten auf um dich kontaktieren zu können."
              )
            ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }